const ResearchOutlineIllustration = () => (
  <svg
    width="585"
    height="337"
    viewBox="0 8 585 337"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Report document */}
    <rect x="0.5" y="10" width="200" height="260" rx="8" className="stroke-fg-secondary/30" />

    {/* Title lines */}
    <rect x="20" y="30" width="100" height="4" rx="2" className="fill-fg-secondary/30" />
    <rect x="20" y="42" width="60" height="3" rx="1.5" className="fill-fg-secondary/25" />

    {/* Chart area inside document */}
    <rect x="20" y="60" width="160" height="80" rx="4" className="stroke-fg-secondary/20" />

    {/* Scatter dots */}
    <circle cx="35" cy="125" r="3" className="fill-fg-secondary/30" />
    <circle cx="48" cy="118" r="2.5" className="fill-fg-secondary/25" />
    <circle cx="58" cy="110" r="3.5" className="fill-fg-secondary/30" />
    <circle cx="72" cy="105" r="2" className="fill-fg-secondary/25" />
    <circle cx="82" cy="112" r="4" className="fill-fg-secondary/20" />
    <circle cx="90" cy="98" r="3" className="fill-fg-secondary/30" />
    <circle cx="100" cy="102" r="2.5" className="fill-fg-secondary/25" />
    <circle cx="108" cy="95" r="3.5" className="fill-fg-secondary/30" />
    <circle cx="118" cy="88" r="2" className="fill-fg-secondary/20" />
    <circle cx="128" cy="92" r="4" className="fill-fg-secondary/30" />
    <circle cx="140" cy="82" r="3" className="fill-fg-secondary/25" />
    <circle cx="150" cy="78" r="3.5" className="fill-fg-secondary/30" />
    <circle cx="162" cy="72" r="5" className="fill-fg-secondary/25" />
    <circle cx="45" cy="130" r="2" className="fill-fg-secondary/20" />
    <circle cx="75" cy="120" r="2.5" className="fill-fg-secondary/20" />
    <circle cx="115" cy="108" r="2" className="fill-fg-secondary/20" />

    {/* Trend line */}
    <path
      d="M32 128 Q80 108 120 92 T168 72"
      className="stroke-fg-secondary/20"
      strokeWidth="1"
      strokeDasharray="3 2"
      fill="none"
    />

    {/* Text lines below chart */}
    <rect x="20" y="155" width="140" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="20" y="165" width="120" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="20" y="175" width="155" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="20" y="185" width="90" height="3" rx="1.5" className="fill-fg-secondary/20" />

    {/* Stats row */}
    <rect x="20" y="205" width="45" height="30" rx="4" className="stroke-fg-secondary/20" />
    <rect x="75" y="205" width="45" height="30" rx="4" className="stroke-fg-secondary/20" />
    <rect x="130" y="205" width="45" height="30" rx="4" className="stroke-fg-secondary/20" />

    <rect x="28" y="212" width="28" height="4" rx="2" className="fill-fg-secondary/25" />
    <rect x="28" y="222" width="18" height="3" rx="1.5" className="fill-fg-secondary/15" />
    <rect x="83" y="212" width="28" height="4" rx="2" className="fill-fg-secondary/25" />
    <rect x="83" y="222" width="18" height="3" rx="1.5" className="fill-fg-secondary/15" />
    <rect x="138" y="212" width="28" height="4" rx="2" className="fill-fg-secondary/25" />
    <rect x="138" y="222" width="18" height="3" rx="1.5" className="fill-fg-secondary/15" />

    {/* Second panel — table/breakdown */}
    <rect x="230" y="10" width="200" height="140" rx="8" className="stroke-fg-secondary/30" />

    {/* Table header */}
    <rect x="245" y="28" width="80" height="3" rx="1.5" className="fill-fg-secondary/30" />
    <line x1="245" y1="40" x2="415" y2="40" className="stroke-fg-secondary/15" />

    {/* Table rows */}
    <rect x="245" y="50" width="50" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="360" y="50" width="35" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="405" y="50" width="20" height="3" rx="1.5" className="fill-fg-secondary/15" />

    <rect x="245" y="65" width="60" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="360" y="65" width="30" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="405" y="65" width="20" height="3" rx="1.5" className="fill-fg-secondary/15" />

    <rect x="245" y="80" width="45" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="360" y="80" width="38" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="405" y="80" width="20" height="3" rx="1.5" className="fill-fg-secondary/15" />

    <rect x="245" y="95" width="55" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="360" y="95" width="25" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="405" y="95" width="20" height="3" rx="1.5" className="fill-fg-secondary/15" />

    <rect x="245" y="110" width="40" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="360" y="110" width="32" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="405" y="110" width="20" height="3" rx="1.5" className="fill-fg-secondary/15" />

    <rect x="245" y="125" width="50" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="360" y="125" width="28" height="3" rx="1.5" className="fill-fg-secondary/20" />
    <rect x="405" y="125" width="20" height="3" rx="1.5" className="fill-fg-secondary/15" />

    {/* Third panel — scatter/bubble */}
    <rect x="230" y="165" width="200" height="105" rx="8" className="stroke-fg-secondary/30" />

    {/* Scatter dots */}
    <circle cx="260" cy="240" r="4" className="fill-fg-secondary/25" />
    <circle cx="280" cy="225" r="5" className="fill-fg-secondary/20" />
    <circle cx="305" cy="215" r="3.5" className="fill-fg-secondary/25" />
    <circle cx="320" cy="230" r="4.5" className="fill-fg-secondary/20" />
    <circle cx="345" cy="205" r="6" className="fill-fg-secondary/25" />
    <circle cx="370" cy="210" r="4" className="fill-fg-secondary/20" />
    <circle cx="390" cy="195" r="5" className="fill-fg-secondary/25" />
    <circle cx="410" cy="190" r="7" className="fill-fg-secondary/20" />

    {/* Magnifying glass overlay */}
    <circle cx="390" cy="50" r="35" className="stroke-fg-secondary/20" strokeWidth="3" />
    <line
      x1="415"
      y1="75"
      x2="440"
      y2="100"
      className="stroke-fg-secondary/20"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
)

export default ResearchOutlineIllustration
